import { useMemo } from "react";
import { IHttpClient } from "../../../lib/http";
import { BillingEntity } from "../domain/Billing.entity";
import { BillingDto, toEntity } from "./Billing.dto";

async function getBillingReport(
  client: IHttpClient,
  date: string,
  tickers: string[]
): Promise<BillingEntity[]> {
  const response = await client.post<string[], BillingDto[]>(
    `/api/billings/properties/snapshot/${date}`,
    tickers
  );
  return response.map(it => toEntity(it));
}

export const useBillingReportApi = (client: IHttpClient) => {
  return useMemo(
    () => ({
      getBillingReport: (date: string, tickers: string[]) =>
        getBillingReport(client, date, tickers),
    }),
    [client]
  );
};
